import { make, Payload } from "vuex-pathify"
import * as defaults from "./defaults"
import SmartAudiencesAPI from "@/api/smartAudiences"

import _ from "lodash"

const state = () => {
  return {
    smartAudiences: [],
    model: Object.assign({}, defaults.MODEL_SMART_AUDIENCE),
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  updateProductUrl({ commit, state }, { index, path, value }) {
    const array = _.get(state.model, "products")
    array[index][path] = value
    commit("SET_MODEL", new Payload(null, "products", array))
  },

  addProduct({ commit, state }) {
    const array = _.get(state.model, "products")

    array.push({ ...defaults.PRODUCT_OBJECT })

    commit("SET_MODEL", new Payload(null, "products", array))
  },

  removeProduct({ commit, state }, { index }) {
    const array = _.get(state.model, "products")

    array.splice(index, 1)

    commit("SET_MODEL", new Payload(null, "products", array))
  },

  clearSmartAudiencesModel({ commit }) {
    commit("SET_MODEL", Object.assign({}, defaults.MODEL_SMART_AUDIENCE))
  },

  deleteSmartAudienceDraft({ commit, state }, draftId) {
    return SmartAudiencesAPI.deleteSmartAudienceDraft(draftId).then(() => {
      const smartAudiences = state.smartAudiences

      smartAudiences.splice(
        state.smartAudiences.findIndex(function(i) {
          return i.id === draftId
        }),
        1
      )

      commit("SET_SMART_AUDIENCES", smartAudiences)
    })
  },

  getSmartAudienceDrafts({ commit, rootGetters }) {
    const adAccount = rootGetters["accounts/adAccountId"]

    return SmartAudiencesAPI.getAdAccountSmartAudienceDrafts(adAccount).then(
      response => {
        commit("SET_SMART_AUDIENCES", response)
      }
    )
  },

  getSmartAudienceDraft({ commit, rootGetters }, { draftId }) {
    return SmartAudiencesAPI.getAdAccountSmartAudienceDraft(draftId).then(
      response => {
        const model = {
          isPublished: response.isPublished,
          name: response.name,
          spec: response.spec,
          products: response.smartAudienceDraftProducts.map(item => item.spec),
        }

        commit("SET_MODEL", model)
      }
    )
  },

  saveSmartAudienceDraft({ rootGetters, state }) {
    const adAccount = rootGetters["accounts/adAccountId"]

    return SmartAudiencesAPI.postAdAccountSmartAudienceDraft(
      adAccount,
      state.model
    )
  },

  updateSmartAudienceDraft({ rootGetters, state }, { draftId }) {
    return SmartAudiencesAPI.patchAdAccountSmartAudienceDraft(draftId, {
      draftData: state.model,
    })
  },
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.smartAudiences = []
    state.model = Object.assign({}, defaults.MODEL_SMART_AUDIENCE)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
